import React from 'react';
import styles from './tv-guide.module.scss';
import { useFocusable, FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { TvGuideChannel } from '@smart-tv/pages/tv-guide/types';
import TvGuideDayViewContext from '../utils/tv-guide-day-view-context';
import TvGuideProgramsRow from './tv-guide-programs-row';
import TvGuideEmpty from './tv-guide-empty';

interface Props {
  channels: TvGuideChannel[];
}

const TvGuidePrograms: React.FC<Props> = (props: Props) => {
  const { channels } = props;

  const { ref, focusKey, hasFocusedChild } = useFocusable({ trackChildren: true });
  const { setGridFocused, scaledConstants } = React.useContext(TvGuideDayViewContext);

  React.useEffect(() => {
    setGridFocused(hasFocusedChild);
  }, [hasFocusedChild, setGridFocused]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div className={styles['tv-guide-programs']} ref={ref}>
        {channels.map((channel, channelIndex) => {
          if (channel.programs.length) {
            return (
              <TvGuideProgramsRow
                key={channel.sid}
                channel={channel}
                channelIndex={channelIndex}
                channelsLength={channels.length}
              />
            );
          } else {
            const top = channelIndex * (scaledConstants.programHeight + scaledConstants.programGap);
            return <TvGuideEmpty key={channel.sid} channel={channel} style={{ top }} />;
          }
        })}
      </div>
    </FocusContext.Provider>
  );
};

export default React.memo(TvGuidePrograms);
